import { FeatureIntrosStore } from '../../interfaces/FeatureIntros';

export const featureIntrosSelector = (state: FeatureIntrosStore) => state.data;

export const setFeatureIntrosSelector = (state: FeatureIntrosStore) =>
  state.setData;
